// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BASIC */
.Login {
  background-color: white;
}

.banner {
  margin-top: 200px;
}

html {
  background-color: #56baed;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
  border: 0.5px solid #56baed;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  border-radius: 0 0 10px 10px;
}

/* TABS */
h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/
input[type=button], input[type=submit], input[type=reset] {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover, input[type=submit]:hover, input[type=reset]:hover {
  background-color: #39ace7;
}

input[type=button]:active, input[type=submit]:active, input[type=reset]:active {
  transform: scale(0.95);
}

input[type=text], input[type=password] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus, input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder, input[type=password] {
  color: #cccccc;
}

/* ANIMATIONS */
/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  animation-name: fadeInDown;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
/* Simple CSS3 Fade-in Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 1s;
}

.fadeIn.first {
  animation-delay: 0.4s;
}

.fadeIn.second {
  animation-delay: 0.6s;
  border: 0.5px solid #56baed;
}

.fadeIn.third {
  animation-delay: 0.8s;
  border: 0.5px solid #56baed;
}

.fadeIn.fourth {
  animation-delay: 1s;
  border: 0.5px solid #56baed;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */
*:focus {
  outline: none;
}

#icon {
  width: 60%;
}

.mat-badge-content {
  background: #5ea1d8;
}

.img-div-left {
  position: fixed;
  z-index: 999;
  height: 150px;
  width: 150px;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/edit-comment/edit-comment.component.scss"],"names":[],"mappings":"AACA,UAAA;AAEA;EAEE,uBAAA;AAFF;;AAIA;EACA,iBAAA;AADA;;AAGA;EACA,yBAAA;AAAA;;AAGA;EACA,kCAAA;EACA,aAAA;AAAA;;AAGA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AAAA;;AAGA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AAAA;;AAKA,cAAA;AAEA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAHA;;AAMA;EAEA,kCAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EAEA,4CAAA;EACA,kBAAA;EACA,2BAAA;AAHA;;AAOA;EACA,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,kBAAA;EAEA,4BAAA;AAJA;;AASA,SAAA;AAEA;EACA,cAAA;AAPA;;AAUA;EACA,cAAA;EACA,gCAAA;AAPA;;AAYA,mBAAA;AAEA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EAEA,iDAAA;EAEA,8BAAA;EACA,0BAAA;EAKA,gCAAA;AAVA;;AAaA;EACA,yBAAA;AAVA;;AAaA;EAKA,sBAAA;AAVA;;AAaA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EAKA,gCAAA;EAEA,8BAAA;AAVA;;AAaA;EACA,sBAAA;EACA,gCAAA;AAVA;;AAaA;EACA,cAAA;AAVA;;AAeA,eAAA;AAEA,uCAAA;AACA;EAEA,0BAAA;EAEA,sBAAA;EAEA,yBAAA;AAbA;AA6BA;EACA;IACA,UAAA;IAEA,mCAAA;EAdE;EAgBF;IACA,UAAA;IAEA,eAAA;EAdE;AACF;AAiBA,kCAAA;AAGA;EAAoB;IAAO,UAAA;EACzB;EADsC;IAAK,UAAA;EAI3C;AACF;AAHA;EACA,UAAA;EAGA,2BAAA;EAIA,6BAAA;EAIA,sBAAA;AAGA;;AAAA;EAGA,qBAAA;AAGA;;AACA;EAGA,qBAAA;EACA,2BAAA;AAEA;;AAEA;EAGA,qBAAA;EACA,2BAAA;AACA;;AAEA;EAGA,mBAAA;EACA,2BAAA;AACA;;AAEA,kCAAA;AACA;EACA,cAAA;EACA,OAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AACA;;AAEA;EACA,cAAA;AACA;;AAEA;EACA,WAAA;AACA;;AAIA,WAAA;AAEA;EACA,aAAA;AAFA;;AAKA;EACA,UAAA;AAFA;;AAIA;EACE,mBAAA;AADF;;AAKA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAFF","sourcesContent":["\n/* BASIC */\n\n.Login{\n\n  background-color: white;\n}\n.banner{\nmargin-top:200px;\n}\nhtml {\nbackground-color: #56baed;\n}\n\nbody {\nfont-family: \"Poppins\", sans-serif;\nheight: 100vh;\n}\n\na {\ncolor: #92badd;\ndisplay:inline-block;\ntext-decoration: none;\nfont-weight: 400;\n}\n\nh2 {\ntext-align: center;\nfont-size: 16px;\nfont-weight: 600;\ntext-transform: uppercase;\ndisplay:inline-block;\nmargin: 40px 8px 10px 8px;\ncolor: #cccccc;\n}\n\n\n\n/* STRUCTURE */\n\n.wrapper {\ndisplay: flex;\nalign-items: center;\nflex-direction: column;\njustify-content: center;\nwidth: 100%;\nmin-height: 100%;\npadding: 20px;\n}\n\n#formContent {\n-webkit-border-radius: 10px 10px 10px 10px;\nborder-radius: 10px 10px 10px 10px;\nbackground: #fff;\npadding: 30px;\nwidth: 90%;\nmax-width: 450px;\nposition: relative;\npadding: 0px;\n-webkit-box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);\nbox-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);\ntext-align: center;\nborder: 0.5px solid #56baed;\n\n}\n\n#formFooter {\nbackground-color: #f6f6f6;\nborder-top: 1px solid #dce8f1;\npadding: 25px;\ntext-align: center;\n-webkit-border-radius: 0 0 10px 10px;\nborder-radius: 0 0 10px 10px;\n}\n\n\n\n/* TABS */\n\nh2.inactive {\ncolor: #cccccc;\n}\n\nh2.active {\ncolor: #0d0d0d;\nborder-bottom: 2px solid #5fbae9;\n}\n\n\n\n/* FORM TYPOGRAPHY*/\n\ninput[type=button], input[type=submit], input[type=reset]  {\nbackground-color: #56baed;\nborder: none;\ncolor: white;\npadding: 15px 80px;\ntext-align: center;\ntext-decoration: none;\ndisplay: inline-block;\ntext-transform: uppercase;\nfont-size: 13px;\n-webkit-box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);\nbox-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);\n-webkit-border-radius: 5px 5px 5px 5px;\nborder-radius: 5px 5px 5px 5px;\nmargin: 5px 20px 40px 20px;\n-webkit-transition: all 0.3s ease-in-out;\n-moz-transition: all 0.3s ease-in-out;\n-ms-transition: all 0.3s ease-in-out;\n-o-transition: all 0.3s ease-in-out;\ntransition: all 0.3s ease-in-out;\n}\n\ninput[type=button]:hover, input[type=submit]:hover, input[type=reset]:hover{\nbackground-color: #39ace7;\n}\n\ninput[type=button]:active, input[type=submit]:active, input[type=reset]:active  {\n-moz-transform: scale(0.95);\n-webkit-transform: scale(0.95);\n-o-transform: scale(0.95);\n-ms-transform: scale(0.95);\ntransform: scale(0.95);\n}\n\ninput[type=text],input[type=password] {\nbackground-color: #f6f6f6;\nborder: none;\ncolor: #0d0d0d;\npadding: 15px 32px;\ntext-align: center;\ntext-decoration: none;\ndisplay: inline-block;\nfont-size: 16px;\nmargin: 5px;\nwidth: 85%;\nborder: 2px solid #f6f6f6;\n-webkit-transition: all 0.5s ease-in-out;\n-moz-transition: all 0.5s ease-in-out;\n-ms-transition: all 0.5s ease-in-out;\n-o-transition: all 0.5s ease-in-out;\ntransition: all 0.5s ease-in-out;\n-webkit-border-radius: 5px 5px 5px 5px;\nborder-radius: 5px 5px 5px 5px;\n}\n\ninput[type=text]:focus, input[type=password]:focus {\nbackground-color: #fff;\nborder-bottom: 2px solid #5fbae9;\n}\n\ninput[type=text]:placeholder, input[type=password] {\ncolor: #cccccc;\n}\n\n\n\n/* ANIMATIONS */\n\n/* Simple CSS3 Fade-in-down Animation */\n.fadeInDown {\n-webkit-animation-name: fadeInDown;\nanimation-name: fadeInDown;\n-webkit-animation-duration: 1s;\nanimation-duration: 1s;\n-webkit-animation-fill-mode: both;\nanimation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n0% {\nopacity: 0;\n-webkit-transform: translate3d(0, -100%, 0);\ntransform: translate3d(0, -100%, 0);\n}\n100% {\nopacity: 1;\n-webkit-transform: none;\ntransform: none;\n}\n}\n\n@keyframes fadeInDown {\n0% {\nopacity: 0;\n-webkit-transform: translate3d(0, -100%, 0);\ntransform: translate3d(0, -100%, 0);\n}\n100% {\nopacity: 1;\n-webkit-transform: none;\ntransform: none;\n}\n}\n\n/* Simple CSS3 Fade-in Animation */\n@-webkit-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }\n@-moz-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }\n@keyframes fadeIn { from { opacity:0; } to { opacity:1; } }\n\n.fadeIn {\nopacity:0;\n-webkit-animation:fadeIn ease-in 1;\n-moz-animation:fadeIn ease-in 1;\nanimation:fadeIn ease-in 1;\n\n-webkit-animation-fill-mode:forwards;\n-moz-animation-fill-mode:forwards;\nanimation-fill-mode:forwards;\n\n-webkit-animation-duration:1s;\n-moz-animation-duration:1s;\nanimation-duration:1s;\n}\n\n.fadeIn.first {\n-webkit-animation-delay: 0.4s;\n-moz-animation-delay: 0.4s;\nanimation-delay: 0.4s;\n\n}\n\n.fadeIn.second {\n-webkit-animation-delay: 0.6s;\n-moz-animation-delay: 0.6s;\nanimation-delay: 0.6s;\nborder: 0.5px solid #56baed;\n}\n\n\n.fadeIn.third {\n-webkit-animation-delay: 0.8s;\n-moz-animation-delay: 0.8s;\nanimation-delay: 0.8s;\nborder: 0.5px solid #56baed;\n}\n\n.fadeIn.fourth {\n-webkit-animation-delay: 1s;\n-moz-animation-delay: 1s;\nanimation-delay: 1s;\nborder: 0.5px solid #56baed;\n}\n\n/* Simple CSS3 Fade-in Animation */\n.underlineHover:after {\ndisplay: block;\nleft: 0;\nbottom: -10px;\nwidth: 0;\nheight: 2px;\nbackground-color: #56baed;\ncontent: \"\";\ntransition: width 0.2s;\n}\n\n.underlineHover:hover {\ncolor: #0d0d0d;\n}\n\n.underlineHover:hover:after{\nwidth: 100%;\n}\n\n\n\n/* OTHERS */\n\n*:focus {\noutline: none;\n}\n\n#icon {\nwidth:60%;\n}\n.mat-badge-content {\n  background:#5ea1d8;\n}\n\n\n.img-div-left{\n  position: fixed;\n  z-index: 999;\n  height: 150px;\n  width: 150px;\n  overflow: visible;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
